import blockquote from '../../icons/non-prefilled/16x16/blockquote.svg';
import bold from '../../icons/non-prefilled/16x16/bold.svg';
import button from '../../icons/non-prefilled/16x16/button.svg';
import code from '../../icons/non-prefilled/16x16/code.svg';
import codeBlock from '../../icons/non-prefilled/16x16/codeBlock.svg';
import comment from '../../icons/non-prefilled/16x16/comment.svg';
import copy from '../../icons/non-prefilled/16x16/copy.svg';
import editLink from '../../icons/non-prefilled/16x16/edit.svg';
import edit from '../../icons/non-prefilled/16x16/editPost.svg';
import equation from '../../icons/non-prefilled/16x16/equation.svg';
import expand from '../../icons/non-prefilled/16x16/expand.svg';
import flowchart from '../../icons/non-prefilled/16x16/flowchart.svg';
import h1 from '../../icons/non-prefilled/16x16/h1.svg';
import h2 from '../../icons/non-prefilled/16x16/h2.svg';
import h3 from '../../icons/non-prefilled/16x16/h3.svg';
import heightLarge from '../../icons/non-prefilled/16x16/heightLarge.svg';
import heightMedium from '../../icons/non-prefilled/16x16/heightMedium.svg';
import heightSmall from '../../icons/non-prefilled/16x16/heightSmall.svg';
import heightXSmall from '../../icons/non-prefilled/16x16/heightXSmall.svg';
import highlight from '../../icons/non-prefilled/16x16/highlight.svg';
import iframe from '../../icons/non-prefilled/16x16/iframe.svg';
import image from '../../icons/non-prefilled/16x16/image.svg';
import imageLeft from '../../icons/non-prefilled/16x16/imageLeft.svg';
import imageRight from '../../icons/non-prefilled/16x16/imageRight.svg';
import italic from '../../icons/non-prefilled/16x16/italic.svg';
import link from '../../icons/non-prefilled/16x16/link.svg';
import listBulleted from '../../icons/non-prefilled/16x16/listBulleted.svg';
import listChecked from '../../icons/non-prefilled/16x16/listChecked.svg';
import listNumbered from '../../icons/non-prefilled/16x16/listNumbered.svg';
import profile from '../../icons/non-prefilled/16x16/member.svg';
import removeHighlight from '../../icons/non-prefilled/16x16/remove.svg';
import spanDefault from '../../icons/non-prefilled/16x16/spanDefault.svg';
import spanFull from '../../icons/non-prefilled/16x16/spanFull.svg';
import spanHalf from '../../icons/non-prefilled/16x16/spanHalf.svg';
import strikethrough from '../../icons/non-prefilled/16x16/strikethrough.svg';
import table from '../../icons/non-prefilled/16x16/table.svg';
import text from '../../icons/non-prefilled/16x16/text.svg';
import unlink from '../../icons/non-prefilled/16x16/unlink.svg';
import divider from '../../icons/prefilled/16x16/divider.svg';
import hintError from '../../icons/prefilled/16x16/hintError.svg';
import hintInfo from '../../icons/prefilled/16x16/hintInfo.svg';
import hintSuccess from '../../icons/prefilled/16x16/hintSuccess.svg';
import hintWarning from '../../icons/prefilled/16x16/hintWarning.svg';

export const boldIcon = bold;
export const italicIcon = italic;
export const strikethroughIcon = strikethrough;
export const codeIcon = code;
export const codeBlockIcon = codeBlock;
export const h1Icon = h1;
export const h2Icon = h2;
export const h3Icon = h3;
export const listBulletedIcon = listBulleted;
export const listNumberedIcon = listNumbered;
export const listCheckedIcon = listChecked;

export const blockquoteIcon = blockquote;
export const hintWarningIcon = hintWarning;
export const hintInfoIcon = hintInfo;
export const hintErrorIcon = hintError;
export const hintSuccessIcon = hintSuccess;

export const tableIcon = table;
export const imageIcon = image;
export const iframeIcon = iframe;
export const dividerIcon = divider;
export const profileIcon = profile;
export const linkIcon = link;
export const textIcon = text;
export const commentIcon = comment;
export const editIcon = edit;
export const copyIcon = copy;
export const unlinkIcon = unlink;
export const editLinkIcon = editLink;
export const spanFullIcon = spanFull;
export const spanDefaultIcon = spanDefault;
export const spanHalfIcon = spanHalf;
export const imageLeftIcon = imageLeft;
export const imageRightIcon = imageRight;
export const highlightIcon = highlight;
export const removeHighlightIcon = removeHighlight;
export const heightLargeIcon = heightLarge;
export const heightMediumIcon = heightMedium;
export const heightSmallIcon = heightSmall;
export const heightXSmallIcon = heightXSmall;
export const expandIcon = expand;
export const flowchartIcon = flowchart;
export const equationIcon = equation;
export const buttonIcon = button;
